import { createDate } from 'core/utils/date'

import {
  type BidState,
  type CarrierInviteState,
  type RfpState,
  type RfpSummary,
} from '../domain/RfpSummary'

export type RawRfpSummary = {
  rfp_id: number
  rfp_name: string
  rfp_state: string
  rfp_request_deadline: string
  rfp_contract_start: string
  rfp_contract_end: string
  shipper_name: string
  lanes_count: number
  lane_proposals_count: number
  awarded_lane_proposals_count: number
  pending_awarded_lane_proposals_count: number
  award_confirmation_deadline: string | null
  state: string
  invite_id: string
  invite_link_uuid: string
  bid_state: string
}

export function mapApiToRfpSummary(rawRfp: RawRfpSummary): RfpSummary {
  return {
    rfpId: rawRfp.rfp_id,
    rfpName: rawRfp.rfp_name,
    rfpState: rawRfp.rfp_state as RfpState,
    rfpRequestDeadline: createDate(rawRfp.rfp_request_deadline)!,
    rfpContractStart: createDate(rawRfp.rfp_contract_start)!,
    rfpContractEnd: createDate(rawRfp.rfp_contract_end)!,
    shipperName: rawRfp.shipper_name,
    lanesCount: rawRfp.lanes_count,
    laneProposalsCount: rawRfp.lane_proposals_count,
    awardedLaneProposalsCount: rawRfp.awarded_lane_proposals_count,
    pendingAwardedLaneProposalsCount: rawRfp.pending_awarded_lane_proposals_count,
    awardConfirmationDeadline: createDate(rawRfp.award_confirmation_deadline),
    carrierInviteState: rawRfp.state as CarrierInviteState,
    inviteId: rawRfp.invite_id,
    inviteLinkUuid: rawRfp.invite_link_uuid,
    bidState: rawRfp.bid_state as BidState,
  }
}
